import { createRouter, createWebHashHistory } from 'vue-router'
import ReportView from '../views/ReportView.vue'
import AdminView from '../views/AdminView.vue'

const routes = [
  {
    path: '/',
    name: 'report',
    component: ReportView,
    meta: { title: '隐患上报' }
  },
  {
    path: '/report',
    redirect: '/'
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminView,
    meta: { title: '安环后台' }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
})

export default router
